import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import NewHeadline from "../../shared/NewHeadline";
import WebViewTabHeader from "./WebViewTabHeader";

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    font-family: var(--font-family-vito);
`;

const ChangeData = styled.div`
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.red.toString()};
    font-size: 1.25rem;

    ${({ theme }) => theme.breakpoints.from.small.css`
    font-size: 1rem;
    `}

    &:hover {
        cursor: pointer;
    }
`;

const CalculatorHeader = ({
    isWebview,
    headline,
    hideChangeData,
    onClickChangeData,
}) => {
    // On web views the Tabs between pellets and heating oil should be switchable
    if (isWebview) {
        // In addition, control if the tabview should be active via a `withTabs` URL parameter
        return (
            <WebViewTabHeader
                onClickChangeData={onClickChangeData}
                hideChangeData={hideChangeData}
            />
        );
    }

    return (
        <HeaderContainer>
            <NewHeadline
                underline
                css={css`
                    padding-bottom: 5px;
                `}
            >
                {headline}
            </NewHeadline>
            {!hideChangeData && (
                <ChangeData onClick={onClickChangeData}>
                    Eingaben ändern
                </ChangeData>
            )}
        </HeaderContainer>
    );
};
export default CalculatorHeader;
